module.exports = __webpack_public_path__ + "img/zuijia_44.a111b240.png";